
export const useNavigationState = () => {

  const navigationStore = useNavigationStore();
  const isNavigationOpen = navigationStore.isNavigationOpen;

  const toggleNavigation = () => {

    setFirstLevelCategory();
    navigationStore.toggleNavigation(!isNavigationOpen.value);
  
  };

  const setFirstLevelCategory = (slug: string = '') => {

    navigationStore.setCurrentFirstLevelCategorySlug(slug);
  
  };

  const currentFirstLevelCategorySlug = navigationStore.currentFirstLevelCategorySlug;
  const currentSecondLevelCategoryName: Ref<Maybe<string>> = ref('');
  const currentSecondLevelCategorySlug: Ref<Maybe<string>> = ref('');

  return {
    isNavigationOpen,
    toggleNavigation,
    currentFirstLevelCategorySlug,
    setFirstLevelCategory,
    currentSecondLevelCategoryName,
    currentSecondLevelCategorySlug,
  };

};
